import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const Modal = (props: any) => {
  const { isOpen, setIsOpen, children, title } = props;

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className={tw`relative z-50`} onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className={tw`fixed inset-0 bg-black bg-opacity-25`} />
          </Transition.Child>

          <div className={tw`fixed inset-0 overflow-y-auto`}>
            <div
              className={tw`flex min-h-full items-center justify-center p-4 text-center`}
            >
              <Transition.Child
                as={Fragment}
                enter={tw`ease-out duration-300`}
                enterFrom={tw`opacity-0`}
                enterTo={tw`opacity-100`}
                leave={tw`ease-in duration-200`}
                leaveFrom={tw`opacity-100`}
                leaveTo={tw`opacity-0`}
              >
                <Dialog.Panel
                  className={tw`w-full min-h-[400px] max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all`}
                >
                  <Dialog.Title
                    as="h3"
                    className={tw`text-lg font-medium leading-6 text-gray-900 flex justify-between`}
                  >
                    {title}
                    <p className={tw`cursor-pointer`} onClick={closeModal}>
                      Close
                    </p>
                  </Dialog.Title>
                  {children}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default Modal;
